import React from "react";
import "./Midsection.css";

const Midsection = () => {
  return (
    <>
      <div className="midmain">
        <div className="midsub">
          <h1>My Projects</h1>
          <p>
            I'm a bit of a explorer. Over my past experinces, I've used
            hundreds of websites and mobile apps in different industries and
            verticals. Eventually, I decided that it would be a fun challenge to
            try designing and building websites.
          </p>
        </div>
      </div>
    </>
  );
};

export default Midsection;
